import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { motion } from "framer-motion";
import classes from "./Explore.module.css";

const categories = [
  {
    id: "career",
    title: "Career",
    emoji: "💼",
    desc: "Explore questions about work, growth, and professional purpose.",
    gradient: "linear-gradient(135deg, #667eea, #764ba2)",
  },
  {
    id: "education",
    title: "Education",
    emoji: "📚",
    desc: "Dive into learning, curiosity, and knowledge.",
    gradient: "linear-gradient(135deg, #43cea2, #185a9d)",
  },
  {
    id: "finance",
    title: "Finance",
    emoji: "💰",
    desc: "Think about money, security, and financial freedom.",
    gradient: "linear-gradient(135deg, #ff9966, #ff5e62)",
  },
  {
    id: "fun",
    title: "Fun",
    emoji: "🎉",
    desc: "Play with questions about joy, hobbies, and adventure.",
    gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
  },
  {
    id: "relationship",
    title: "Relationship",
    emoji: "❤️",
    desc: "Explore love, family, and connection with others.",
    gradient: "linear-gradient(135deg, #ff6a88, #ff99ac)",
  },
  {
    id: "self",
    title: "Self",
    emoji: "🌱",
    desc: "Reflect on identity, growth, and self-discovery.",
    gradient: "linear-gradient(135deg, #11998e, #38ef7d)",
  },
];

const Explore = () => {
  const navigate = useNavigate();
  const [customQuestion, setCustomQuestion] = useState("");
  const [loadingCategory, setLoadingCategory] = useState(null);

  const startCustomFlow = () => {
    if (!customQuestion.trim()) return;
    navigate("/ideamap", {
      state: {
        graphData: {
          nodes: [{ id: "root", question: customQuestion, answer: "", x: 0, y: 0, level: 0 }],
          links: [],
        },
      },
    });
  };

  const startCategoryFlow = async (categoryId) => {
    setLoadingCategory(categoryId);
    try {
      const qSnap = await getDocs(
        collection(db, "resources", "categories", categoryId, "questions", "items")
      );
      const docs = qSnap.docs.map(doc => doc.data().question);
      if (!docs.length) {
        alert("No questions found for this category!");
        setLoadingCategory(null);
        return;
      }
      const random = docs[Math.floor(Math.random() * docs.length)];

      navigate("/ideamap", {
        state: {
          graphData: {
            nodes: [{ id: "root", question: random, answer: "", x: 0, y: 0, level: 0 }],
            links: [],
          },
        },
      });
    } catch (err) {
      console.error("Error fetching category questions:", err);
    } finally {
      setLoadingCategory(null);
    }
  };

  return (
    <div className={classes.container}>

        <div style={{ textAlign: "center", marginBottom: "2rem", display: "flex", flexDirection: "row", alignItems: "center" }}>
            <h1>Explore Ideas</h1>
            <p style={{ color: "#555", maxWidth: "600px", margin: "0 auto" }}>
                Choose your own question or spark curiosity through one of our curated
                categories. Every path leads to a new flow of thoughts — where will you
                start?
            </p>
            </div>
      {/* Custom Question */}
      <motion.div
        className={classes.customBox}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2>Choose Your Own Question</h2>
        <input
          type="text"
          placeholder="Type your question here..."
          value={customQuestion}
          onChange={(e) => setCustomQuestion(e.target.value)}
          className={classes.input}
        />
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className={classes.actionBtn}
          onClick={startCustomFlow}
        >
          Enter Flow State
        </motion.button>
      </motion.div>

      {/* Categories */}
      <div className={classes.grid}>
        {categories.map((cat) => (
          <motion.div
            key={cat.id}
            className={classes.card}
            style={{ background: cat.gradient }}
            whileHover={{ y: -5 }}
          >
            <div className={classes.cardContent}>
              <span className={classes.emoji}>{cat.emoji}</span>
              <h3>{cat.title}</h3>
              <p>{cat.desc}</p>
              <motion.button
                className={classes.actionBtn}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => startCategoryFlow(cat.id)}
                disabled={loadingCategory === cat.id}
              >
                {loadingCategory === cat.id ? "Loading..." : "Explore"}
              </motion.button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Explore;
